/**
 * Taxonomy-business-type template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeBusinessBrowser from './lib/partials/ThemeBusinessBrowser';
import ThemeLogoMarquee from './lib/partials/ThemeLogoMarquee';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Taxonomy-business-type';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initThemeBusinessBrowser();
	initThemeLogoMarquees();
}

/**
 * initThemeBusinessBrowser - Initialize the ThemeBusinessBrowser
 * @returns
 */
const initThemeBusinessBrowser = () => {
	Logger.info(`${NAME} > initThemeBusinessBrowser`);

	const dom = document.querySelector(`[data-theme-business-browser]`);
	if (!dom) return;

	const el = new ThemeBusinessBrowser(dom);
	el.init();
}


/**
 * initThemeLogoMarquees - Initialize the theme logo marquee
 * @returns
 */
const initThemeLogoMarquees = () => {
	Logger.info(`${NAME} > initThemeLogoMarquees`);
	const themeLogoMarquees = document.querySelectorAll('[data-theme-logo-marquee]');
	if (!themeLogoMarquees) return;
	themeLogoMarquees.forEach(themeLogoMarquee => {
		const el = new ThemeLogoMarquee(themeLogoMarquee);
		el.init();
	});
}


// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
